import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

export enum SearchSize {
  Medium = 'medium',
  Large = 'large'
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchComponent),
      multi: true
    }
  ],
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements ControlValueAccessor {
  placeholder: InputSignal<string> = input<string>('Type to search');
  buttonLabel: InputSignal<string> = input<string>('');
  buttonClick: OutputEmitterRef<Event> = output<Event>();

  size: InputSignal<SearchSize> = input<SearchSize>(SearchSize.Medium);

  // State
  isDisabled: WritableSignal<boolean> = signal<boolean>(false);
  value: WritableSignal<string> = signal<string>('');

  onSearchChange(event: Event): void {
    const value: string = (event.target as HTMLInputElement).value;

    this.value.set(value);
    this.onChange?.(value);
  }

  private onChange?: (value: string) => void;
  onTouch?: () => void;

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  writeValue(outsideValue: string): void {
    this.value.set(outsideValue);
  }
}
